// Filtres du plan d'action, conservés dans l'URL pour qu'une vue se partage par simple lien.

import { DEFAULT_FILTERS, type PlanFilters, type PlanView } from '@cockpit/shared';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const VIEWS: PlanView[] = ['plan', 'drift', 'dates', 'sav', 'rec'];
const numOrNull = (s: string | null) =>
  s === null || s === '' || Number.isNaN(Number(s)) ? null : Math.max(0, Number(s));

export function usePlanFilters(): [PlanFilters, (patch: Partial<PlanFilters>) => void] {
  const [params, setParams] = useSearchParams();
  const f = useMemo<PlanFilters>(() => {
    const view = params.get('vue') as PlanView | null;
    return {
      ent: params.get('ent') ?? DEFAULT_FILTERS.ent,
      ty: params.get('type') ?? '',
      view: view && VIEWS.includes(view) ? view : 'plan',
      kinds: (params.get('k') ?? '').split(',').filter(Boolean),
      prio: (params.get('prio') as PlanFilters['prio']) ?? DEFAULT_FILTERS.prio,
      who: params.get('resp') ?? '',
      q: params.get('q') ?? '',
      fmax: numOrNull(params.get('facture')),
      camin: numOrNull(params.get('ca')),
      dmode: (params.get('derive') as PlanFilters['dmode']) ?? DEFAULT_FILTERS.dmode,
      rmode: (params.get('rappro') as PlanFilters['rmode']) ?? DEFAULT_FILTERS.rmode,
      smode: (params.get('achats') as PlanFilters['smode']) ?? DEFAULT_FILTERS.smode,
      trt: (params.get('traite') as PlanFilters['trt']) ?? DEFAULT_FILTERS.trt,
    };
  }, [params]);

  const update = useCallback(
    (patch: Partial<PlanFilters>) => {
      const n = { ...f, ...patch };
      const p = new URLSearchParams();
      const put = (k: string, v: string | number | null, def: string | number | null = '') => {
        if (v !== null && v !== '' && v !== def) p.set(k, String(v));
      };
      put('ent', n.ent, 'Tous');
      put('type', n.ty);
      put('vue', n.view, 'plan');
      put('k', n.kinds.join(','));
      put('prio', n.prio, DEFAULT_FILTERS.prio);
      put('resp', n.who);
      put('q', n.q);
      put('facture', n.fmax);
      put('ca', n.camin);
      put('derive', n.dmode, DEFAULT_FILTERS.dmode);
      put('rappro', n.rmode, DEFAULT_FILTERS.rmode);
      put('achats', n.smode, DEFAULT_FILTERS.smode);
      put('traite', n.trt, DEFAULT_FILTERS.trt);
      setParams(p, { replace: true });
    },
    [f, setParams],
  );
  return [f, update];
}
